// EmployeeLayout.jsx - Final version

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import EmployeeHeader from "./components/header/EmployeeHeader";
import { ClientStatusProvider } from "../../views/context/clientContext";
import { HeaderSlotProvider } from "../../contexts/HeaderSlotContext";

export default function EmployeeLayout() {
  const location = useLocation();
  // Full-bleed (edge-to-edge, own pastel background): the home dashboard and the
  // request-detail page. Every other employee page keeps the standard padded frame.
  const isHome =
    /^\/employee\/?(home)?$/.test(location.pathname) ||
    /^\/employee\/my-request\/[^/]+/.test(location.pathname);

  return (
    <ClientStatusProvider>
      <HeaderSlotProvider>
      <div className="flex flex-col w-full h-screen" style={{ background: "linear-gradient(160deg,#D9D2FF 0%,#FBF7F6 45%,#FBF6F4 100%)" }}>
        {/* Header */}
        <EmployeeHeader />

        {/* Main Content */}
        <main
          className={`flex-1 min-h-0 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}
        >
          <div className={isHome ? "w-full h-full" : "p-2 w-full h-full"}>
            <Outlet />
          </div>
        </main>
      </div>
      </HeaderSlotProvider>
    </ClientStatusProvider>
  );
}